<div class="gmap-wrapper">
    <div class="nav-header">
        <div style="display: flex; gap: 16px; padding: 16px">
            <mat-icon aria-hidden="true" (click)="closeDialog()" class="arrow-back">arrow_back</mat-icon>
            <span class="brand-text"> Choose Delivery Location </span>
        </div>

        <div class="search-container">
            <img src="{{ DEPLOY_URL }}/assets/images/map-search.svg" class="search-icon" alt="search" />
            <input
                type="text"
                appGooglePlace
                autocomplete="off"
                placeholder="Search for area, street name etc."
                [isHeader]="isHeader"
                [mode]="mode"
                class="google-place-input full-width"
                (onSelect)="afterSelection($event)"
                [(ngModel)]="googleInputsearchText" />

            @if (googleInputsearchText?.length > 0) {
                <button class="cross-icon center" (click)="clearSearchText()">&#10005;</button>
            }
        </div>
    </div>

    <div style="position: relative">
        <div class="gMap">
            <div #map id="map"></div>
            <button [disabled]="findingLocality || !googleMap" class="locate-me-container center" (click)="locateMe()">
                <img src="{{ DEPLOY_URL }}/assets/images/locate-me.svg" class="locate-me-icon" alt="locate-me" />
                <span class="locate-me"> Use Current Location </span>
            </button>
            @if (!isDragging) {
                <span class="pin-placement-text center"> Place pin at the exact location </span>
            }
            <div class="center-marker"></div>
        </div>
    </div>

    <div class="locality-container">
        <div class="locality">
            <div class="heading-text">
                @if (currentLocation?.heading_text) {
                    <img src="{{ DEPLOY_URL }}/assets/images/address-location-sm.svg" class="address-location" alt="marker" />
                }
                @if (!findingLocality) {
                    <span>
                        {{ currentLocation?.heading_text }}
                    </span>
                }
                @if (findingLocality) {
                    <span> Locating... </span>
                }
            </div>

            @if (findingLocality) {
                <div>
                    <app-selector [style]="{ 'border-radius': '4px' }"></app-selector>
                    <app-selector [style]="{ 'border-radius': '4px', width: '60%' }"></app-selector>
                </div>
            }

            @if (!findingLocality) {
                <span class="formatted-address">
                    @if (!currentLocation?.heading_text) {
                        <img src="{{ DEPLOY_URL }}/assets/images/address-location.svg" class="address-location" alt="marker" />
                    }
                    {{ currentLocation?.formatted_address }}
                </span>
            }
        </div>

        <button class="confirm-location center" (click)="selectLocality()" [disabled]="findingLocality">Confirm Location</button>
    </div>
</div>
